import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import StatsCard from '../StatsCard';
import {
  IconClock,
  IconPills,
  IconTimeline,
  IconUsers,
} from '@tabler/icons-react';
import coverageVerificationAnalyticService from '../../../services/coverage-verification-analytics.service';

const VerificationStatsCards = ({ filters }) => {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await coverageVerificationAnalyticService.getCoverageVerificationStats(
            {
              ...filters,
            },
          );
        setStatsData(data);
      } catch (err) {
        console.error('Error fetching stats:', err);
        setError('Failed to load statistics.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [filters]);

  if (error) {
    return (
      <Col>
        <div className="text-danger">{error}</div>
      </Col>
    );
  }

  const totalVerifications =
    statsData?.total_verifications?.total_coverage_verifications;
  const uniqueDrugsVerified =
    statsData?.unique_drugs_verified?.unique_drugs_verified;
  const averageVerificationPerProvider =
    statsData?.average_verifications_per_provider
      ?.average_verifications_per_provider;
  const averageTimeToCompletion =
    statsData?.time_to_completion?.average_duration_ms;
  const averageTimeInSeconds = averageTimeToCompletion
    ? (averageTimeToCompletion / 1000).toFixed(2)
    : null;

  return (
    <>
      <Col sm={6} xl={3} className="mb-4 mb-xl-0">
        <StatsCard
          title="Total Verifications"
          value={totalVerifications ?? '-'}
          icon={<IconClock size={24} />}
          color="primary"
          loading={loading}
        />
      </Col>
      <Col sm={6} xl={3} className="mb-4 mb-xl-0">
        <StatsCard
          title="Unique Drugs Verified"
          value={uniqueDrugsVerified ?? '-'}
          icon={<IconPills size={24} />}
          color="success"
          loading={loading}
        />
      </Col>
      <Col sm={6} xl={3} className="mb-4 mb-xl-0">
        <StatsCard
          title="Average Verifications (Provider)"
          value={averageVerificationPerProvider ?? '-'}
          icon={<IconUsers size={24} />}
          color="info"
          loading={loading}
        />
      </Col>
      <Col sm={6} xl={3} className="mb-4 mb-xl-0">
        <StatsCard
          title="Avg Time (seconds)"
          value={averageTimeInSeconds ?? '-'}
          icon={<IconTimeline size={24} />}
          color="warning"
          loading={loading}
        />
      </Col>
    </>
  );
};

export default VerificationStatsCards;
